import React from "react";
import { Minus, Plus } from "lucide-react";

export const Stepper = ({ value, onChange, min = 0, testid }) => (
  <div className="flex items-center gap-3" data-testid={testid}>
    <button type="button" onClick={() => onChange(Math.max(min, value - 1))}
      className="h-12 w-12 rounded-xl border bg-card flex items-center justify-center active:scale-95 transition-transform" data-testid={testid ? `${testid}-minus` : undefined}>
      <Minus className="h-5 w-5" />
    </button>
    <div className="min-w-[3rem] text-center text-2xl font-semibold tabular-nums">{value}</div>
    <button type="button" onClick={() => onChange(value + 1)}
      className="h-12 w-12 rounded-xl border bg-primary text-primary-foreground flex items-center justify-center active:scale-95 transition-transform" data-testid={testid ? `${testid}-plus` : undefined}>
      <Plus className="h-5 w-5" />
    </button>
  </div>
);
